import React from 'react';
import { X, CheckCircle2, Circle, ShieldCheck } from 'lucide-react';
import { Button } from '../../components/ui/button';

function ModuleDetails({ module, permissions, onPermissionChange, onSetFullAccess, onSave, saving }) {
  
  const renderPermissionRow = (perm) => {
    const isAllowed = permissions[module.id] && permissions[module.id][perm.id] === true;
    
    return (
      <div key={perm.id} className="flex items-center gap-3 py-2 group cursor-pointer" onClick={() => onPermissionChange(module.id, perm.id, !isAllowed)}>
        <button 
          className="shrink-0 focus:outline-none"
        >
          {isAllowed ? (
            <CheckCircle2 className="w-5 h-5 text-emerald-600" />
          ) : (
            <Circle className="w-5 h-5 text-slate-200 group-hover:text-emerald-300 transition-colors" />
          )}
        </button>
        <div>
          <h5 className={`text-sm font-bold transition-colors ${isAllowed ? 'text-slate-900' : 'text-slate-600'}`}>
            {perm.label}
          </h5>
        </div>
      </div>
    );
  };

  const totalPerms = module.gestion.length + module.consultation.length;
  let allowedCount = 0;
  if (permissions[module.id]) {
    [...module.gestion, ...module.consultation].forEach(p => {
      if (permissions[module.id][p.id] === true) allowedCount++;
    });
  }
  const isFullAccess = allowedCount === totalPerms && totalPerms > 0;

  return (
    <div className="flex flex-col h-full bg-white rounded-2xl relative">
      
      {/* Header */}
      <div className="p-6 pb-4 flex items-center justify-between shrink-0">
        <h3 className="font-bold text-slate-900 text-lg">Droits d'accès : {module.name}</h3>
        <button className="text-slate-500 hover:text-slate-900 p-1">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Permissions List */}
      <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-8">
        
        {module.gestion.length > 0 && (
          <div>
            <h4 className="text-sm font-bold text-slate-600 mb-4">Gestion</h4>
            <div className="space-y-1">
              {module.gestion.map(renderPermissionRow)}
            </div>
          </div>
        )}

        <div className="w-full h-px bg-slate-100"></div>

        {module.consultation.length > 0 && (
          <div>
            <h4 className="text-sm font-bold text-slate-600 mb-4">Consultation</h4>
            <div className="space-y-1">
              {module.consultation.map(renderPermissionRow)}
            </div>
          </div>
        )}

      </div>

      {/* Accès complet Box & Save */}
      <div className="p-6 shrink-0 flex flex-col gap-4 border-t border-transparent">
        <div 
          onClick={onSetFullAccess}
          className={`p-4 rounded-xl border flex items-center gap-4 cursor-pointer transition-colors ${
            isFullAccess 
              ? 'bg-emerald-50 border-emerald-200' 
              : 'bg-slate-50 border-slate-200 hover:border-emerald-300'
          }`}
        >
          <div className="shrink-0">
            <ShieldCheck className={`w-8 h-8 ${isFullAccess ? 'text-emerald-600' : 'text-slate-400'}`} />
          </div>
          <div>
            <h5 className={`font-bold text-sm ${isFullAccess ? 'text-emerald-800' : 'text-slate-800'}`}>
              Accès complet
            </h5>
            <p className={`text-xs mt-0.5 ${isFullAccess ? 'text-emerald-700/80' : 'text-slate-500'}`}>
              Tous les droits pour ce module sont autorisés.
            </p>
          </div>
        </div>

        <Button 
          onClick={onSave} 
          disabled={saving}
          className="bg-emerald-600 hover:bg-emerald-700 text-white w-full h-11 text-sm font-bold rounded-xl"
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </div>

    </div>
  );
}

export default ModuleDetails;
